
import { CalcTax } from "services/CallAPIs"
import { dropdownsAreValid, getFormData } from "services/FormFunctions"
import { determineFormErrors, switchCheckboxsFromOnToTrue } from "services/CalcTaxaFunctions"

import { MapInputsToTaxBody } from "models/BodiesNovaTaxa"
import { WarningIncompleteInputMessage, WarningInvalidInput, ErrorChamadaApi } from "hooks/useAlert"
import { tipoImovelIDFromNome } from "constants/tiposImovel"

export function autoClick(taxaFixa)
{
    // clicar no botão de calcular automaticamente para taxas fixas    
    const submitButton = document.querySelector("button[type=submit]")
    if (taxaFixa & submitButton !== null)
    {
        submitButton.click()
        submitButton.remove()
    }
}


function prepareInput(idServ, inputData)
{
    if (inputData.tipoImovel)
    {
        inputData.tipoImovel = tipoImovelIDFromNome[inputData.tipoImovel]
    }
    
    if (inputData.usoAreaAverbada)
    {
        inputData.usoAreaAverbada = tipoImovelIDFromNome[inputData.usoAreaAverbada]
    }

    switchCheckboxsFromOnToTrue(inputData)

    return MapInputsToTaxBody(idServ, inputData)
}

export async function handleSubmit(event, idServ, setLoading, setValidated, setResults, showAlert)
{
    event.preventDefault()      
    const form = event.currentTarget
    const inputData = getFormData(form)
    const formErrors = determineFormErrors(idServ, inputData)

    if (!form.checkValidity() | !dropdownsAreValid() | 1 <= formErrors.length)
    {
        event.stopPropagation()
        setValidated(false)
        if(!form.checkValidity())
        {
            const message = WarningIncompleteInputMessage()
            showAlert(message.variant, message.header, message.body)
        }
        else if(1 <= formErrors.length){
            const message = WarningInvalidInput(formErrors)
            showAlert(message.variant, message.header, message.body)
        }
        window.scrollTo(0, 0)
        return
    }
    
    setValidated(true)
    setLoading(true)

    const taxBody = prepareInput(idServ, inputData)
    const taxResults = await CalcTax(idServ, taxBody, "v2")

    if(taxResults.error)
    {
        const message = ErrorChamadaApi("calcular taxa", taxResults.error)
        showAlert(message.variant, message.header, message.body)
        window.scrollTo(0, 0)
        setLoading(false)
        return
    }

    setResults(taxResults)
    setLoading(false)
}